import {Routes} from '@angular/router';

export const bannerRecommendationRoutes: Routes = [
  {
    path: 'bannerRecommendation',
    loadComponent: () => import('./banner-recommendation.component').then(m => m.BannerRecommendationComponent),
    data: { title: '轮播图推荐' },
  },
];
